import { render, staticRenderFns } from "./labeled-text.vue?vue&type=template&id=9a80003e&scoped=true&lang=pug"
import script from "./labeled-text.vue?vue&type=script&lang=ts"
export * from "./labeled-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a80003e",
  null
  
)

export default component.exports